<!--
 * @Description:联系人
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-07 17:04:49
 * @LastEditors: cxh
-->
<template>
  <cos-table  v-bind="$attrs" :columns="columns" @fetch="fetch" ref="table">
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'operation'">
        <a-button type="link" @click="handleEdit(record)" :disabled="permissionPage?.isPublic" v-permission="permissionPage?.edit"> 编辑 </a-button>
        <a-button type="link" @click="handleDelete(record)" :disabled="permissionPage?.isPublic" v-permission="permissionPage?.del"> 删除 </a-button>
      </template>
    </template>
  </cos-table>
  <EditModal ref="editModalRef" @success="refresh" />
</template>
<script setup lang="ts">
import { onMounted, reactive, ref, computed } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import dataConfig from '@/views/yuntuSales/commonEnum/dataConfig'
import { customerContactList, customerContactDelete } from '@/api/yuntuSales/customerCenter'
import EditModal from './editModal.vue'
import { listByParamCodes } from '@/api/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
const table = ref()
const editModalRef = ref()
const loading = ref(false)
const props = defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  contactRefId: {
    type: String
  },
  hideOk: {
    type: Boolean
  }
})
const paramCodeData = reactive<{
  lbu_department_title: []
}>({
  lbu_department_title: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_department_title']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const fetch = (params: object, callBack: (res: any) => void) => {
  if (props.contactRefId) {
    customerContactList({
      contactRefId: props.contactRefId,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
onMounted(() => {
  getByParamCodes()
})
const refresh = (type?: 'add' | 'edit') => {
  if (type === 'edit') {
    table.value.fetch()
  } else {
    table.value.search()
  }
}
// // 新增
// const handleAdd = () => {
//   editModalRef.value.toggle()
// }
// 编辑
const handleEdit = (row: PotentialItem['contact']) => {
  editModalRef.value.toggle(row)
}
// 删除
const handleDelete = (row: PotentialItem['contact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      loading.value = true
      customerContactDelete({
        id: row.id,
        contactRefId: row.contactRefId
      })
        .then((res) => {
          table.value.delFetch()
          message.success('删除成功')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const columns = computed(() => {
  const init: any = [
    {
      title: '联系人名称',
      dataIndex: 'name'
    },
    {
      title: '手机号',
      dataIndex: 'mobile'
    },
    {
      title: '邮箱',
      dataIndex: 'email'
    },
    {
      title: '微信号',
      dataIndex: 'wechat'
    },
    {
      title: 'QQ号',
      dataIndex: 'qq'
    },
    {
      title: '固定电话',
      dataIndex: 'tel'
    },
    {
      title: '传真号',
      dataIndex: 'fax'
    },
    {
      title: '性别',
      dataIndex: 'sex',
      dicData: dataConfig.genderEnum
    },
    {
      title: '角色',
      dataIndex: 'jobRole',
      dicData: dataConfig.linkRoleTypeEnum
    },
    {
      title: '职务',
      dataIndex: 'jobDuty',
      dicData: paramCodeData.lbu_department_title
    },
    {
      title: '创建人',
      dataIndex: 'createByName'
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      width: 190
    }
  ]
  if (!props.hideOk) {
    init.push({
      title: '操作',
      dataIndex: 'operation',
      fixed: 'right',
      width: 120
    })
  }
  return init
})
defineExpose({
  refresh
})
</script>
<script lang="ts">
export default {
  name: 'ContactsTable'
}
</script>
